exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".o-link,a{color:tomato;font-size:inherit;font-weight:inherit;letter-spacing:1px;text-transform:uppercase}.o-link,.o-link:focus,.o-link:hover,a,a:focus,a:hover{outline:none;text-decoration:none}", ""]);

// exports
